import {css} from 'lit';
export const styles = css`:host {
  --bar-radius: 3px;
  --bar-max-width: 56px;
}

.columns {
  display: flex;
  gap: var(--bucket-gap);
  align-items: flex-end;
}

.column {
  position: relative;
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: flex-end;
  height: 100%;
}

.fill {
  display: block;
  width: 100%;
  max-width: var(--bar-max-width);
  margin: 0 auto;
  border-radius: var(--bar-radius) var(--bar-radius) 0 0;
  transition: height 0.3s ease;
}

.value {
  position: absolute;
  left: 0;
  right: 0;
  margin-bottom: 4px;
  color: var(--label-color);
  font-size: 0.6875rem;
  font-weight: 600;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  text-align: center;
}
`;
export default styles;
